import { Type, ImageIcon } from 'lucide-react'
import { useLocation } from 'react-router-dom'
import { PageDescription, RoutingTabs } from '@/components/ui'

const videoTabs = [
  {
    id: 'i2v',
    label: 'Image to Video',
    icon: ImageIcon,
    path: '/video/i2v',
    description:
      'Bring an image to life. Animate any photo or character into a moving video clip.',
  },
  {
    id: 't2v',
    label: 'Text to Video',
    icon: Type,
    path: '/video/t2v',
    description:
      'Generate a video clip straight from a text prompt. No source image needed.',
  },
]

export function VideoTabs() {
  const location = useLocation()
  const active = videoTabs.find((tab) => location.pathname === tab.path)
  return (
    <>
      <RoutingTabs items={videoTabs} />
      {active?.description && (
        <PageDescription className="mt-3">{active.description}</PageDescription>
      )}
    </>
  )
}
